import React from 'react';

import { toolbarGroupControlsStyle, toolbarGroupLabelStyle, toolbarGroupStyle } from './toolbar-styles';

export type ToolbarGroupProps = {
	children: React.ReactNode;
	/** Uppercase caption drawn ABOVE the controls, so a row of icons says what it is for */
	label?: string;
	/** Draws the divider that separates this group from the one before it */
	withSeparator?: boolean;
};

export const ToolbarGroup = (props: ToolbarGroupProps): React.ReactElement => {
	const { children, label, withSeparator = true } = props;

	return (
		<div style={toolbarGroupStyle(withSeparator)}>
			<span style={toolbarGroupLabelStyle}>{label ?? ' '}</span>
			<div style={toolbarGroupControlsStyle}>
				{children}
			</div>
		</div>
	);
};
